package one.healthium.today.ui.carni.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import one.healthium.ui.compose.theme.black20
import one.healthium.ui.compose.theme.black50
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun BaseLogControl(
    modifier: Modifier = Modifier,
    containerColor: Color,
    icon: DrawableResource,
    button: String? = null,
    buttonModifier: Modifier = Modifier,
    onClick: () -> Unit = {},
    content: @Composable () -> Unit,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = containerColor,
        shape = AppTheme.shapes.large,
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Spacer(Modifier.width(12.dp))
            Box(
                modifier = Modifier
                    .size(36.dp)
                    .background(black10, RoundedCornerShape(100)),
                contentAlignment = Alignment.Center,
            ) {
                Icon(
                    painter = painterResource(icon),
                    tint = black50,
                    contentDescription = null,
                )
            }
            Spacer(Modifier.width(12.dp))
            Box(
                modifier = Modifier.weight(1f),
            ) {
                content()
            }
            if (button != null) {
                Spacer(Modifier.width(8.dp))
                LogControlButton(
                    modifier = buttonModifier.widthIn(max = 180.dp),
                    title = button,
                    onClick = onClick,
                )
            }
        }
    }
}

@Composable
private fun LogControlButton(
    modifier: Modifier = Modifier,
    title: String,
    onClick: () -> Unit,
) {
    Surface(
        modifier = modifier.height(70.dp),
        color = black20,
        shape = AppTheme.shapes.large,
        onClick = onClick,
    ) {
        Box(
            modifier = Modifier.padding(horizontal = 24.dp),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                text = title,
                style = AppTheme.textStyles.poppins14Bold,
                color = AppTheme.colors.textInverted100,
                textAlign = TextAlign.Center,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}